import '../Donate/Donate.css';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { States } from '../common/States';
import PropTypes from 'prop-types';
import { honoreeErrorCount, navigateForm } from '../Helpers/FormHelper';


export function FormHonoree({
  isSecondPart, bindHonoreeFirstName, errorHonoreeFirstName,
  bindHonoreeLastName, errorHonoreeLastName, bindHonoreeAddress1, errorHonoreeAddress1, bindHonoreeAddress2,
  bindHonoreeCity, errorHonoreeCity, bindHonoreePostalState, errorHonoreePostalState, bindHonoreePostalCode,
  errorHonoreePostalCode, bindHonoreeEmailAddress, errorHonoreeEmailAddress,
  isMe, setIsSecondPart }) {

  const honoreeErrors = () => {
    return honoreeErrorCount(errorHonoreeEmailAddress, errorHonoreePostalCode, errorHonoreePostalState,
      errorHonoreeCity, errorHonoreeAddress1, errorHonoreeLastName, errorHonoreeFirstName)
  }
  return (
    <div className={`${isMe || (!isMe && isSecondPart) ? "hidden" : ""}`}>
      <h2 className="linkHeader">Supporter Information</h2>
      <div className="form-group">
        <label className="control-label">Supporter First Name</label>
        <input className="form-control" name="Honoree First Name" type="text" {...bindHonoreeFirstName} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreeFirstName.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Supporter Last Name</label>
        <input className="form-control" name="Honoree Last Name" type="text" {...bindHonoreeLastName} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreeLastName.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Supporter Address 1</label>
        <input className="form-control" name="Honoree Address 1" type="text" {...bindHonoreeAddress1} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreeAddress1.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Supporter Address 2</label>
        <input className="form-control" name="Honoree Address 2" type="text" {...bindHonoreeAddress2} />
      </div>
      <div className="form-group">
        <label className="control-label">Supporter City</label>
        <input className="form-control" name="Honoree City" type="text" {...bindHonoreeCity} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreeCity.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Supporter State</label>
        <States bindValues={bindHonoreePostalState} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreePostalState.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Supporter Postal Code</label>
        <input className="form-control" name="Honoree Postal Code" type="text" {...bindHonoreePostalCode} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreePostalCode.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Supporter Email Address</label>
        <input className="form-control" name="Email" type="text" {...bindHonoreeEmailAddress} />
        <div className="formError" style={{ color: "red" }}>
          {errorHonoreeEmailAddress.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 text-end">
          <Link to="" onClick={(e) => navigateForm(e, "next", setIsSecondPart)} className={`btn blm-btn-primary right ${honoreeErrors() > 0 ? "disabled" : ""}`}>
            Next <FontAwesomeIcon icon={["fa", "angle-double-right"]} />
          </Link>
        </div>
      </div>
    </div>
  );

}

FormHonoree.propTypes = {
  isSecondPart: PropTypes.bool.isRequired,
  bindHonoreeFirstName: PropTypes.object.isRequired,
  errorHonoreeFirstName: PropTypes.array.isRequired,
  bindHonoreeLastName: PropTypes.object.isRequired,
  errorHonoreeLastName: PropTypes.array.isRequired,
  bindHonoreeAddress1: PropTypes.object.isRequired,
  errorHonoreeAddress1: PropTypes.array.isRequired,
  bindHonoreeAddress2: PropTypes.object.isRequired,
  bindHonoreeCity: PropTypes.object.isRequired,
  errorHonoreeCity: PropTypes.array.isRequired,
  bindHonoreePostalState: PropTypes.object.isRequired,
  errorHonoreePostalState: PropTypes.array.isRequired,
  bindHonoreePostalCode: PropTypes.object.isRequired,
  errorHonoreePostalCode: PropTypes.array.isRequired,
  bindHonoreeEmailAddress: PropTypes.object.isRequired,
  errorHonoreeEmailAddress: PropTypes.array.isRequired,
  isMe: PropTypes.bool.isRequired,
  setIsSecondPart: PropTypes.func.isRequired,
}

